import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2GuestSitePublishedQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type WebsiteV2GuestSitePublishedQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; activeWebsiteV2Site?: { __typename?: 'CarbonWebsiteSite'; id: string; published: boolean } | null } | null;
};

export const WebsiteV2GuestSitePublishedDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2GuestSitePublished' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeWebsiteV2Site' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2GuestSitePublishedQuery__
 *
 * To run a query within a React component, call `useWebsiteV2GuestSitePublishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2GuestSitePublishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2GuestSitePublishedQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useWebsiteV2GuestSitePublishedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2GuestSitePublishedQuery, WebsiteV2GuestSitePublishedQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2GuestSitePublishedQuery, WebsiteV2GuestSitePublishedQueryVariables>(WebsiteV2GuestSitePublishedDocument, baseOptions);
}
export function useWebsiteV2GuestSitePublishedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2GuestSitePublishedQuery, WebsiteV2GuestSitePublishedQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2GuestSitePublishedQuery, WebsiteV2GuestSitePublishedQueryVariables>(WebsiteV2GuestSitePublishedDocument, baseOptions);
}
export type WebsiteV2GuestSitePublishedQueryHookResult = ReturnType<typeof useWebsiteV2GuestSitePublishedQuery>;
export type WebsiteV2GuestSitePublishedLazyQueryHookResult = ReturnType<typeof useWebsiteV2GuestSitePublishedLazyQuery>;
export type WebsiteV2GuestSitePublishedQueryResult = Apollo.QueryResult<WebsiteV2GuestSitePublishedQuery, WebsiteV2GuestSitePublishedQueryVariables>;
